import { Page } from 'resources/types';

export class Subscriber {
  mode: string;
  email?: string;
  endpoint?: string;
  display_phone_number?: string;
  id?: string;

  constructor(
    email: string = '',
    display_phone_number: string = '',
    endpoint: string = '',
    id: string = '',
  ) {
    if (email != '') {
      this.mode = 'email';
    } else if (display_phone_number != '') {
      this.mode = 'sms';
    } else {
      this.mode = 'endpoint';
    }
    this.email = email;
    this.display_phone_number = display_phone_number;
    this.endpoint = endpoint;
    this.id = id;
  }

  static displayMode(subscriber: Subscriber): string | undefined {
    switch (subscriber.mode) {
      case 'email':
        return 'Email';
      case 'sms':
        return 'SMS';
      case 'webhook':
        return 'Webhook';
    }
  }

  static identifier(subscriber: Subscriber): string | undefined {
    switch (subscriber.mode) {
      case 'email':
        return subscriber.email;
      case 'sms':
        return subscriber.display_phone_number;
      case 'webhook':
        return subscriber.endpoint;
    }
  }
}

export interface NewSubscriptionProps {
  page: Page;
  subscriber: Subscriber;
  components: any[];
  formAction: string;
  analyticsPayload: string;
}

export interface EditSubscriptionProps {
  page: Page;
  subscriber: Subscriber;
  components: any[];
  selectedComponentIds: string[];
  allowComponentSubscribers: boolean;
  analyticsPayload: string;
}

export interface ComponentFormProps {
  page: Page;
  components: any[];
  selectedComponentIds: string[];
  allowComponentSubscribers: boolean;
  subscriber: Subscriber;
  formAction: string;
  formMethod: string;
  analyticsPayload: string;
  allowUnsubscribe: boolean;
}

export interface SubscriptionState {
  globalToggleName: string;
  blockSave: boolean;
  initialSubscribeShow: boolean;
}

declare global {
  interface Window {
    Routes: any;
    analyticsClient: any; // this is needed so TS doesn't whine about analyticsClient
    pageColorData: any;
  }
}
